import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

import { Grid, Typography } from "@material-ui/core";
import StepperButton from "components/StepperButton";

const useStyles = makeStyles((theme) => ({
  stepper: {
    width: "auto",
  },
  counterPrimary: {
    width: "40px",
    textAlign: "center",
  },
  counterSecondary: {
    width: "20px",
    textAlign: "center",
  },
  disabledText: {
    color: theme.palette.text.disabled,
  },
}));

const Stepper = (props) => {
  const classes = useStyles();

  const decrementCounter = () => {
    props.onValueChanged(props.name, props.count - 1);
  };

  const incrementCounter = () => {
    props.onValueChanged(props.name, props.count + 1);
  };

  return (
    <Grid
      container
      wrap="nowrap"
      alignItems="center"
      className={classNames(props.className, classes.stepper)}
    >
      <StepperButton
        name={`${props.name}-minus-btn`}
        variant={props.variant}
        aria-label={`decrement ${props.ariaHint} to ${props.count - 1}`}
        onClick={decrementCounter}
        disabled={props.disabled || props.decrementDisabled}
        remove
      />
      <Typography
        variant="caption"
        className={classNames(
          props.variant === "secondary"
            ? classes.counterSecondary
            : classes.counterPrimary,
          props.disabled ? classes.disabledText : null
        )}
      >
        {props.count}
      </Typography>
      <StepperButton
        name={`${props.name}-add-btn`}
        variant={props.variant}
        aria-label={`increment ${props.ariaHint} to ${props.count + 1}`}
        onClick={incrementCounter}
        disabled={props.disabled || props.incrementDisabled}
        add
      />
    </Grid>
  );
};

Stepper.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  count: PropTypes.number.isRequired,
  variant: PropTypes.oneOf(["primary", "secondary"]),
  disabled: PropTypes.bool,
  incrementDisabled: PropTypes.bool,
  decrementDisabled: PropTypes.bool,
  onValueChanged: PropTypes.func,
  ariaHint: PropTypes.string,
};

export default Stepper;
